import React, { useState, useEffect } from "react";
import CardButtonGroup from "../../components/plot_engagement/ActivityCard";
// import LandPrep from "../../assets/svg/LandPrep.svg";
import LandPrepPopup from "./Popup/LandPrepPopup";
import SeedTreatmentPopup from "./Popup/SeedTreatmentPopup";
import SeedCuttingPopup from "./Popup/SeedCuttingPopup";
import BasalDosePopup from "./Popup/BasalDosePopup";
import PreparationIconWithTick from "./IconStatus";
import { useTranslation } from "react-i18next";

//

const PrePlantingCardGroup = ({ status, updateStatus }) => {
  const [popupType, setPopupType] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const openPopup = queryParams.get("openPopup");
  const { t } = useTranslation();

  const setOpenPopupType = () => {
    if (openPopup) {
      setPopupType(openPopup);
    }
  };

  const handleButtonClick = (type) => {
    setPopupType(type);
  };

  useEffect(() => {
    setOpenPopupType();
  }, [openPopup]);

  // const handleButtonClick = (type) => {
  // 	setPopupType(type);
  // };
  const getActivityStatus = (activity) =>
    status && Array.isArray(status) && status[0]?.[activity];
  const closePopup = () => {
    setPopupType(null);
    updateStatus();
  };
  const PrePlantingButtons = [
    {
      label: t("Land Preparation"),
      icon: (
        <PreparationIconWithTick
          status={getActivityStatus("land_preparation")}
          activityType="land_preparation"
        />
      ),
      onClick: () => handleButtonClick("LandPrep"),
    },
    {
      label: t("Seed Treatment"),
      icon: (
        <PreparationIconWithTick
          status={getActivityStatus("seed_treatment")}
          activityType="seed_treatment"
        />
      ),
      onClick: () => handleButtonClick("SeedTreatment"),
    },
    {
      label: t("Seed Cutting"),
      icon: (
        <PreparationIconWithTick
          status={getActivityStatus("seed_cutting")}
          activityType="seed_cutting"
        />
      ),
      onClick: () => handleButtonClick("SeedCutting"),
    },
    {
      label: t("Basal Dose"),
      icon: (
        <PreparationIconWithTick
          status={getActivityStatus("basal_dose")}
          activityType="basal_dose"
        />
      ),
      onClick: () => handleButtonClick("BasalDose"),
    },
  ];
  return (
    <div>
      <CardButtonGroup buttons={PrePlantingButtons} t={t} />
      {popupType === "LandPrep" && <LandPrepPopup onClose={closePopup} t={t} />}
      {popupType === "SeedTreatment" && (
        <SeedTreatmentPopup onClose={closePopup} t={t} />
      )}
      {popupType === "SeedCutting" && (
        <SeedCuttingPopup onClose={closePopup} t={t} />
      )}
      {popupType === "BasalDose" && (
        <BasalDosePopup onClose={closePopup} t={t} />
      )}
    </div>
  );
};

export default PrePlantingCardGroup;
